import moment from "moment-timezone";
import { Box, IconButton, SvgIcon, Typography } from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import {
  CONNECTOR_TIMESTAMP_TYPES,
  DAYS_UP_TO_TODAY,
  ENV_DEV,
  ENV_PRODUCTION,
  ENV_STAGING,
  LAST_30_DAYS_DATE_FORMAT,
  LAST_7_DAY_DATE_FORMAT,
  LAST_MONTH_END_DATE_FORMAT,
  LAST_MONTH_START_DATE_FORMAT,
  MONTH_TO_DATE_FORMAT,
  SDK_BUNDLE_ENABLED_USER_LIST,
  SUPER_ADMIN_ROLE,
  TIMESTAMP_SOURCE,
  TIMESTAMP_TYPE,
  TODAY_DATE_FORMAT,
  YEAR_TO_DATE_FORMAT,
} from "../Constants/Constants";
import Routes from "./Routes";
import SelectComponent from "../common/SelectComponent/SelectComponent";

const styles = {
  parent: {
    fontSize: "22px",
    fontWeight: 400,
    lineHeight: "25.78px",
    color: "#505050",
    p: "0px 12px",
  },
  add: {
    fontSize: "16px",
    fontWeight: 500,
    lineHeight: "18.75px",
    color: "#7F7F7F",
    textAlign: "left",
  },
  addIcon: {
    p: 0,
    // color: "#828282",
  },
  initialMainBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    width: "270px",
    p: "10px",
  },
  headingBox: {
    textAlign: "left",
    width: "250px",
  },
  initialSubBox: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    width: "270px",
    gap: "5px",
    mt: "5px",
  },
};

export const balanceConvertion = (balance) => {
  let newBalance = 0;
  /* istanbul ignore if */
  if (balance !== null) {
    /* istanbul ignore if */
    if (balance < 1073741824) {
      newBalance =
        balance === 0
          ? `${0} MB`
          : `${(balance / (1024 * 1024)).toFixed(2)} ` + "MB";
    }
    /* istanbul ignore if */
    if (balance >= 1073741824 && balance < 1099511627776) {
      newBalance = `${(balance / (1024 * 1024 * 1024)).toFixed(2)} ` + "GB";
    }
    /* istanbul ignore if */
    if (balance >= 1099511627776) {
      newBalance =
        `${(balance / (1024 * 1024 * 1024 * 1024)).toFixed(2)} ` + "TB";
    }
  }
  return newBalance.toString();
};
/* istanbul ignore next */
export const checkDecimalPoint = (value) =>
  Number.isInteger(value) ? value : Number(value.toFixed(2));
/* istanbul ignore next */
export const capFirstLetterCapBeforeSpace = (s) =>
  s?.replace(/([A-Z])/g, " $1")?.replace(/^./, function (str) {
    return str.toUpperCase();
  });
/* istanbul ignore next */
export const standardtDateRange = (range) => {
  // const today = moment();
  let value;
  switch (range) {
    case "LAST_7_DAYS":
      value = {
        date: [LAST_7_DAY_DATE_FORMAT, TODAY_DATE_FORMAT],
        type: "Last 7 Days",
      };
      break;
    case "MONTH_TO_DATE":
      value = {
        date: [MONTH_TO_DATE_FORMAT, TODAY_DATE_FORMAT],
        type: "Month to Date",
      };
      break;
    case "LAST_30_DAYS":
      value = {
        date: [LAST_30_DAYS_DATE_FORMAT, TODAY_DATE_FORMAT],
        type: "Last 30 Days",
      };
      break;
    case "LAST_MONTH":
      value = {
        date: [LAST_MONTH_START_DATE_FORMAT, LAST_MONTH_END_DATE_FORMAT],
        type: "Last Month",
      };
      break;
    case "YEAR_TO_DATE":
      value = {
        date: [YEAR_TO_DATE_FORMAT, TODAY_DATE_FORMAT],
        type: "Year to Date",
      };
      break;
    default:
      break;
  }
  return value;
};
/* istanbul ignore next */
export const selectCustomDateRange = (e, name, prevData) => {
  let value;
  const startDate = e[0];
  const endDate = e[1];
  const today = moment();
  /* istanbul ignore if */
  if (today <= startDate) {
    value = {
      date: [today, null],
      type: "Custom Date",
    };
  } else if (today <= endDate) {
    value = {
      date: [startDate, today],
      type: "Custom Date",
    };
  } else if (endDate !== null && endDate < startDate) {
    value = { date: [endDate, null], type: "Custom Date" };
  } else {
    value = { date: [startDate, endDate], type: "Custom Date" };
  }
  return value;
};
/* istanbul ignore next */
export const daysUpToDate = (e, name, prevData) => {
  const isValidNumber = e.target.value.replace(/[^0-9]/g, "");
  if (isValidNumber !== " ")
    return {
      date: [
        isValidNumber === "1" || isValidNumber === "" || isValidNumber === "0"
          ? TODAY_DATE_FORMAT
          : moment().subtract(isValidNumber - 1, "days"),
        TODAY_DATE_FORMAT,
      ],
      type: `${isValidNumber} ${DAYS_UP_TO_TODAY}`,
      value: isValidNumber === "0" || isValidNumber === "" ? "" : isValidNumber,
    };
  return prevData;
};

/* istanbul ignore next */
export const capitalizeFLetter = (str) => {
  if (!str) return "";
  const strings = str.split(" ");
  return strings
    .map((string) =>
      string ? string.charAt(0).toUpperCase() + string.slice(1) : "",
    )
    .join(" ");
};
/* istanbul ignore next */
export const changeGroupName = (str) =>
  capitalizeFLetter(str?.toLowerCase().split("_").join(" "));
/* istanbul ignore next */
export const dateFormatMMDDYYYY = (date) => moment(date).format("MM-DD-YYYY");

export const addCustomEvent = (player) => {
  /* istanbul ignore if */
  if (!player?.eventList?.length) return player;
  const eventLabels = ["Custom Event", "Dolby Millicast Events All"];
  player.eventList = player.eventList.filter((eventObj) => {
    /* istanbul ignore if */
    if (eventLabels.includes(eventObj.label)) {
      eventObj.group =
        eventObj.label === "Custom Event" ? "Custom Data" : "Dolby Millicast";
      player.metaDataList.push(eventObj);
      return false;
    }
    return true;
  });
  return player;
};

export const updateFilterName = (filter) => ({
  ...filter,
  adFrameWork: filter?.adFrameWork?.map((item) =>
    item === "Yospace" ? "YoSpace" : item,
  ),
});
export const clearSessionDetails = () => {
  const sessionNames = [
    "sortDatapipe",
    "sortCollector",
    "sortConnector",
    "companyFilter",
    "userFilter",
    "dataDictionaryFilter",
    "customDataFilter",
  ];
  sessionNames.forEach((key) => sessionStorage.removeItem(key));
};

export function SvgCustomIcon({ value, style, svgStyle }) {
  return (
    <SvgIcon style={svgStyle}>
      <path d={value} style={style} />
    </SvgIcon>
  );
}
export function changeExtensionToSvg(url) {
  return url.replace(".png", ".svg");
}
export function datapointGroupCount(groupCounts, item) {
  if (!groupCounts[item.mainGroup]) {
    groupCounts[item.mainGroup] = {};
  }

  // Handle subgroups for Metadata
  if (item.group === "Metadata") {
    if (!groupCounts[item.mainGroup][item.group]) {
      groupCounts[item.mainGroup][item.group] = {};
    }
    if (!groupCounts[item.mainGroup][item.group][item.subGroup]) {
      groupCounts[item.mainGroup][item.group][item.subGroup] = 0;
    }
    // Increment count if item is selected or required
    if (item.selected || item.required) {
      groupCounts[item.mainGroup][item.group][item.subGroup]++;
    }
  } else {
    if (!groupCounts[item.mainGroup][item.group]) {
      groupCounts[item.mainGroup][item.group] = 0;
    }
    // Increment count if item is selected or required
    if (item.selected || item.required) {
      groupCounts[item.mainGroup][item.group]++;
    }
  }
  return groupCounts;
}
export function resetDatapointGroupCount(groupCounts, item) {
  if (!groupCounts[item.mainGroup]) {
    groupCounts[item.mainGroup] = {};
  }

  // Only reset counts if item.required is false
  if (!item.required) {
    // Handle subgroups for Metadata
    if (item.group === "Metadata") {
      if (!groupCounts[item.mainGroup][item.group]) {
        groupCounts[item.mainGroup][item.group] = {};
      }
      groupCounts[item.mainGroup][item.group][item.subGroup] = 0;
    } else {
      groupCounts[item.mainGroup][item.group] = 0;
    }
  }
  return groupCounts;
}

export const getCollectorDetailsKeyAndName = (details, key) =>
  details?.[key]
    ? {
        key: details[key].key,
        name: details[key].name,
        status: details[key].status,
        jiraIntegrationStatus: details[key].jiraIntegrationStatus,
        type: details[key].type,
        id: details[key].id,
        supportSampling: details[key].supportSampling,
        appSessionTimeOut: details[key].supportAppSessionTimeOut,
        cmcdStatus: details[key].supportCmcd,
        collectorImage: details[key].collectorImage,
        visibility: details[key].visibility,
      }
    : null;

export function transformDataWithIDAndName(data) {
  return data.map((item) => ({
    id: item?.datapipeId,
    name: item?.datapipeName,
  }));
}

export const createHeaderLabel = (title, isExpanded) => (
  <Box
    sx={{
      ...styles.headingBox,
      ...(isExpanded ? { width: "467px" } : {}),
    }}
  >
    <Typography
      sx={{
        ...styles.parent,
        ...(isExpanded ? { p: "0px" } : {}),
      }}
    >
      {title}
    </Typography>
  </Box>
);

export const createConfigLabel = (handleAddFn, labelText, isExpanded) => (
  <Box
    sx={{
      ...styles.initialMainBox,
      ...(isExpanded ? { width: "467px", p: "10px 0px" } : {}),
    }}
  >
    <Box sx={styles.initialSubBox}>
      <IconButton aria-label="close" onClick={handleAddFn} sx={styles.addIcon}>
        <AddCircleOutlineIcon sx={{ width: 40, height: 40 }} />
      </IconButton>{" "}
      <Typography sx={styles.add}>{labelText}</Typography>
    </Box>
  </Box>
);

export const handleBreadcrumbRoute = (
  titleName,
  pathnames,
  titleNameTwo,
  selectedName,
  selectedSubName,
  selectedCoSubName,
) => {
  const createRoute = (name, route, options = {}) => ({
    name,
    route,
    ...options,
  });

  const routingRules = {
    "data-pipe-list": [
      createRoute(titleName, Routes.datapipeList, { disabled: true }),
      createRoute("Data Pipe List", Routes.datapipeList, { disabled: true }),
    ],
    "data-pipe-details": [
      createRoute(titleName, Routes.datapipeList, { disabled: false }),
      createRoute("Data Pipe Details", Routes.datapipeList, { disabled: true }),
    ],
    "view-pipe": [
      createRoute(titleName, Routes.datapipeList),
      createRoute(titleNameTwo, Routes.datapipeList),
      createRoute("View Pipe", Routes.viewPipe, { disabled: true }),
    ],
    "edit-pipe": [
      createRoute(titleName, Routes.datapipeList),
      createRoute(titleNameTwo, Routes.datapipeList),
      createRoute("Edit Pipe", Routes.editPipe, { disabled: true }),
    ],
    "collector-list": [
      createRoute(titleName, Routes.collectorList, { disabled: true }),
      createRoute("Collector List", Routes.collectorList, { disabled: true }),
    ],
    "collector-configuration": [
      createRoute(titleName, Routes.collectorList),
      createRoute("Collector Configuration", Routes.collectorConfiguration, {
        disabled: true,
      }),
    ],
    "connector-list": [
      createRoute(titleName, Routes.connectorList, { disabled: true }),
      createRoute("Connector List", Routes.connectorList),
    ],
    "connector-configuration": [
      createRoute(titleName, Routes.connectorList),
      createRoute("Connector Configuration", Routes.connectorConfiguration, {
        disabled: true,
      }),
    ],
    users: [
      createRoute(titleName, Routes.dashboard, { disabled: true }),
      createRoute("Users", Routes.dashboard, { selected: true }),
    ],
    projects: [
      createRoute(titleName, Routes.dashboard, { disabled: true }),
      createRoute("Projects", Routes.dashboard, { selected: true }),
    ],
    "custom-data": [
      createRoute(titleName, Routes.dashboard, { disabled: true }),
      createRoute("Custom Data", Routes.dashboard, { selected: true }),
    ],
    "billing-usage": [
      createRoute(titleName, Routes.dashboard, { disabled: true }),
      createRoute("Billing & Usage", Routes.dashboard, { selected: true }),
    ],
    companies: [
      createRoute(titleName, Routes.dashboard, { disabled: true }),
      createRoute("Companies", Routes.dashboard, { selected: true }),
    ],
    "rate-cards": [
      createRoute(titleName, Routes.dashboard, { disabled: true }),
    ],
    "data-point-management": [
      createRoute(titleName, Routes.dashboard, { disabled: true }),
      createRoute("Data Point Management", Routes.dashboard, {
        selected: true,
      }),
    ],
    "collector-management": [
      createRoute(titleName, Routes.dashboard, { disabled: true }),
      createRoute("Collector Management", Routes.dashboard, { selected: true }),
    ],
    "epg-enrichment": [
      createRoute(titleName, Routes.dashboard, { disabled: true }),
      createRoute("EPG Enrichment", Routes.epg_enrichment, { selected: true }),
    ],
  };

  const breadcrumbSegments =
    routingRules[pathnames.join("/")]?.map((rule) => ({
      ...rule,
      disabled: rule.disabled ?? false,
    })) || [];

  [selectedName, selectedSubName, selectedCoSubName].forEach((name) => {
    if (name) breadcrumbSegments.push({ name });
  });
  return breadcrumbSegments;
};

export const handleChunkError = async (event) => {
  const message = event?.message || event?.reason?.message || "";
  if (!message.includes("ChunkLoadError")) return;

  if (sessionStorage.getItem("chunkErrorReloaded")) {
    console.error("ChunkLoadError: reload already attempted. Skipping reload.");
    return;
  }

  console.warn(
    "ChunkLoadError detected. Clearing browser caches and reloading...",
  );
  sessionStorage.setItem("chunkErrorReloaded", "true");

  try {
    if ("caches" in window) {
      const cacheNames = await caches.keys();
      await Promise.all(cacheNames.map(caches.delete));
    }
  } catch (error) {
    console.error("Error clearing caches:", error);
  }

  setTimeout(() => window.location.reload(true), 500);
};

export const isValidEmail = (email) => {
  const emailRegex =
    /^(([^<>()[\]\\.,:\s@"]+(\.[^<>()[\]\\.,:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return emailRegex.test(email.trim());
};

export const handleInputChange = (e, state, requiredField = []) => {
  const { name, value } = e.target;
  const updatedState = {
    ...state,
    [name]: value,
    errors: {},
  };
  const isFilled = requiredField.every((field) => updatedState[field]?.trim());
  return {
    ...updatedState,
    buttonState: !isFilled,
  };
};
export const emailIcon = (
  <EmailOutlinedIcon
    sx={{
      color: "#007ac9",
      fontSize: "75px",
    }}
  />
);
export const errorIcon = (
  <ErrorOutlineIcon
    sx={{
      color: "#007ac9",
      fontSize: "74px",
    }}
  />
);

export const AuthStatus = {
  DEFAULT: "default",
  SUCCESS: "success",
  ERROR: "error",
};

export const focusAndSelectFields = (refs, ...keys) => {
  keys.forEach((key) => {
    const ref = refs[key];
    if (ref?.current) {
      ref.current.focus();
      setTimeout(() => {
        try {
          ref.current.select();
        } catch (err) {
          console.warn(`Select failed for ${key}:`, err);
        }
      }, 0);
    }
  });
};

export function getLSAuth() {
  const loggedInDataStr = localStorage.getItem("session_details");
  const loggedInData = loggedInDataStr ? JSON.parse(loggedInDataStr) : {};
  return loggedInData;
}

export function getHeaderColor(env, role) {
  const isDevOrStaging = [ENV_DEV, ENV_STAGING].includes(env);
  const isProdSuperAdmin = env === ENV_PRODUCTION && role === SUPER_ADMIN_ROLE;

  if (isDevOrStaging) return "#ff3300";
  if (isProdSuperAdmin) return "#008000";

  return "#000A12";
}

export const formatExecutedOn = (dateString, timeZone) => {
  if (!dateString) return "";
  const utcDate = moment.utc(dateString);

  if (timeZone === "UTC") {
    return `${utcDate.format("YYYY-MM-DD @ hh:mm A")} UTC`;
  }

  const localZone = moment.tz.guess();
  const localDate = utcDate.clone().tz(localZone);

  return localDate.format("YYYY-MM-DD @ hh:mm A z");
};

export const formatExecutedOnv2 = (dateString, timeZone, format) => {
  if (!dateString) return "";
  const utcDate = moment.utc(dateString);

  if (timeZone === "UTC") {
    return `${utcDate.format(format)} UTC`;
  }

  const systemZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return utcDate.clone().tz(systemZone).format(`${format} z`);
};

export const getPipeNewUI = () => {
  return localStorage.getItem("newPipeUI") !== "false";
};

export const timestampSelectComponent = (data, onChangeSelect, styles) => (
  <Box sx={styles.timestamp_box_style}>
    <SelectComponent
      name={TIMESTAMP_SOURCE}
      labelName={TIMESTAMP_TYPE}
      defaultValue={data?.timestampSource}
      data={CONNECTOR_TIMESTAMP_TYPES}
      onChangeSelect={onChangeSelect}
      variant="outlined"
      size="small"
      removeLabel={{ start: 0 }}
      style={styles.select_style}
      formControlStyle={styles.form_control_style}
    />
  </Box>
);

export const areImagesEqual = (oldImage, newImage) => {
  if (!oldImage && newImage) {
    return true;
  }
  if (oldImage && !newImage) {
    return true;
  }
  if (!oldImage && !newImage) {
    return false;
  }
  if (
    oldImage?.name !== newImage?.name ||
    oldImage?.size !== newImage?.size ||
    oldImage?.type !== newImage.type ||
    oldImage?.lastModified !== newImage?.lastModified
  ) {
    return true;
  }
};

export const getCollectorImage = (v) =>
  v?.api?.collectorImage ||
  v?.adFramework?.collectorImage ||
  v?.mediaPlayer?.collectorImage ||
  v?.application?.collectorImage;

export const isValidUrl = (value) => {
  const regex = /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/\S*)?$/;
  return regex.test(value);
};

export const checkVersionFlag = (data) => {
  for (const item of data) {
    const { currentVersion, latestVersion } = item;

    if (!latestVersion) continue;

    const c = currentVersion?.split(".").map(Number);
    const l = latestVersion?.split(".").map(Number);
    const maxLength = Math.max(c.length, l.length);

    for (let i = 0; i < maxLength; i++) {
      const cur = c[i] || 0;
      const lat = l[i] || 0;

      if (lat > cur) return true;
      if (lat < cur) break;
    }
  }

  return false;
};
export const validateUrl = (value) => {
  const regex = /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/\S*)?$/;
  return regex.test(value);
};

export const isSuperAdminBundle = (roleName) =>
  process.env.REACT_APP_SDK_BUNDLE === "true" && roleName === SUPER_ADMIN_ROLE;

export const isOtherUserBundle = (roleName) =>
  process.env.REACT_APP_SDK_BUNDLE_OTHERS === "true" &&
  SDK_BUNDLE_ENABLED_USER_LIST.includes(roleName);

export const shouldShowSdkBundle = (roleName, collector) =>
  collector?.customSdkBundled &&
  (isSuperAdminBundle(roleName) || isOtherUserBundle(roleName));

export const isNewCollectorConfig = () =>
  process.env.REACT_APP_SDK_BUNDLE === "true" &&
  process.env.REACT_APP_SDK_BUNDLE_OTHERS === "true";

export const getComponentByRoles = (roleName, components) => {
  const { newComponent, defaultComponent } = components;
  return isSuperAdminBundle(roleName) || isOtherUserBundle(roleName)
    ? newComponent
    : defaultComponent;
};
export const checkMajorVersionFlag = (data) => {
  for (const item of data) {
    const { currentVersion, latestVersion } = item;
    if (!latestVersion) continue;
    const currentMajor = parseInt(currentVersion?.split(".")[0]) || 0;
    const latestMajor = parseInt(latestVersion?.split(".")[0]) || 0;
    if (latestMajor > currentMajor) return true;
  }
  return false;
};

export const getDisplayValue = (rawValue) => {
  try {
    const cleaned =
      typeof rawValue === "string"
        ? rawValue.trim().replace(/\.$/, "")
        : rawValue;

    const parsed =
      typeof cleaned === "string" ? JSON.parse(cleaned || "{}") : cleaned || {};

    const inner = parsed?.bq_table_mapping ?? {};
    return JSON.stringify(inner, null, 2);
  } catch {
    return typeof rawValue === "string" ? rawValue : "";
  }
};

export const buildCustomerMap = (displayValue) => {
  try {
    const cleaned = displayValue.trim().replace(/\.$/, "");
    const parsed = JSON.parse(cleaned);

    const inner = parsed?.bq_table_mapping ?? parsed;

    return `${JSON.stringify({ bq_table_mapping: inner })}.`;
  } catch (e) {
    return null;
  }
};

export const decodeJwt = (token) => {
  if (!token || typeof token !== "string") return null;

  const parts = token.split(".");
  if (parts.length !== 3) return null;

  try {
    const base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");

    const binary = window.atob(base64);
    const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));

    const json = new TextDecoder().decode(bytes);
    return JSON.parse(json);
  } catch (err) {
    console.error("Token decode failed:", err);
    return null;
  }
};

export const getTokenExpiryDetails = (token) => {
  if (!token) {
    return {
      expiryDate: null,
      isExpired: false,
      isNearingExpiration: false,
    };
  }
  const tokenData = decodeJwt(token);
  const exp = tokenData?.exp;
  const expiryDate = exp ? moment(exp * 1000) : null;
  const isExpired = expiryDate ? moment().isAfter(expiryDate) : false;
  const isNearingExpiration =
    expiryDate && !isExpired && expiryDate.diff(moment(), "days") <= 30;

  return {
    expiryDate,
    isExpired,
    isNearingExpiration,
  };
};

export const getBigQueryMapping = (data = [], catchAllSupported) => {
  return data?.map((item, index) => ({
    bigQueryAliasName: {
      value: item?.name,
      alias: item?.type === "Custom Alias",
      aliasId: item?.key?.replace(/^custom\./, ""),
      unmapped: item?.type === "Custom Key",
      dictionary: item?.type === "Dictionary",
    },
    customKey: {
      value: item?.key || "--",
    },
    type: {
      value:
        item?.type?.toLowerCase() === "custom key" && item?.source
          ? `${item?.type} (${item?.source})`
          : item?.type,
    },
    bigQueryFieldName: {
      value: item?.fieldName || (catchAllSupported ? "catch_all" : "--"),
      orignalBqValue: item?.fieldName || "",
      alias: item?.type === "Custom Alias",
      isCatchAllGrayOut: !item?.fieldName && catchAllSupported,
      unmapped: item?.type === "Custom Key",
      dictionary: item?.type === "Dictionary",
      bigQueryAliasName: item?.name,
      customKey: item?.key || "--",
      type: item?.type,
      index,
      customerMappingId: item?.customerMappingId,
      customAliasId: item?.customAliasId,
      enrichmentFieldId: item?.enrichmentFieldId,
      key: String(index + 1),
      name: item?.name,
    },
    key: String(index + 1),
    supported: {
      value: "No",
    },
  }));
};

export const mapWithRestrictions = (
  list,
  restrictionList,
  matchKey,
  itemKey,
) => {
  if (!Array.isArray(list)) return [];

  const cleanedList = list.map((item) => ({
    ...(item && typeof item === "object" ? item : {}),
    restricted: false,
  }));

  if (!Array.isArray(restrictionList) || restrictionList.length === 0) {
    return cleanedList;
  }

  return cleanedList.map((item) => {
    const match = restrictionList.some((r) => r[matchKey] === item[itemKey]);
    return { ...item, restricted: match };
  });
};

export const backspaceGuard = (event) => {
  event.stopPropagation();
  event.preventDefault();
};

export const formatCapitalCase = (str) => {
  if (!str) return str;
  return str[0].toUpperCase() + str.slice(1).toLowerCase();
};

let epgCompanyDetails = null;
let epgFetchPromise = null;

export const isEpgCompanyDetailsLoaded = () => epgCompanyDetails !== null;

export const loadEpgCompanyDetails = (force = false) => {
  if (!epgFetchPromise || force) {
    const publicUrl = process.env.PUBLIC_URL || "";
    const url = `${publicUrl}/data/companyEpg.json?_t=${Date.now()}`;
    epgFetchPromise = fetch(url, {
      cache: "no-store",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(
            `Failed to load companyEpg.json (HTTP ${res.status})`,
          );
        }
        return res.json();
      })
      .then((json) => {
        if (Array.isArray(json)) {
          epgCompanyDetails = json;
        } else {
          epgCompanyDetails = [];
        }
        return epgCompanyDetails;
      })
      .catch((err) => {
        console.error("Error loading companyEpg.json:", err);
        epgCompanyDetails = [];
        return epgCompanyDetails;
      });
  }
  return epgFetchPromise;
};

export const companyEpgDetails = (uuid, key) => {
  if (!epgCompanyDetails || !uuid || !key) return undefined;
  const companyEpgDetail = epgCompanyDetails?.find(
    (t) => t?.companyUUID === uuid,
  );
  if (!companyEpgDetail) return undefined;

  const result = companyEpgDetail[key];

  if (Array.isArray(result)) {
    return result.map((item) => {
      const str = String(item ?? "").trim();
      return {
        label: str.charAt(0).toUpperCase() + str.slice(1).toLowerCase(),
        value: item,
      };
    });
  }

  if (result && typeof result === "object") {
    return Object.entries(result).map(([objKey, obj]) => ({
      label: obj?.displayName ?? objKey,
      value: objKey,
    }));
  }

  return result;
};

export const companySupportedByEpg = (uuid) => {
  if (!epgCompanyDetails || !uuid) return false;
  return epgCompanyDetails.some((t) => t?.companyUUID === uuid);
};
